import { StepGroupTypes } from "../../enum/StepGroupTypes";
import { Step } from "./Step";
import { StepFactory } from "../../../application/services/StepFactory";
const stepFactory = new StepFactory();

export class StepGroup {
    private _name: string;
    private _order: number;
    private _type: number;
    private _steps: Step[];

    constructor(stepGroup: any, processConfigurationPayExemptions: any[], processConfigurationAuthorizations: any[]) {
        this._name = StepGroupTypes.translations[stepGroup.type].name;
        this._order = stepGroup.order;
        this._type = stepGroup.type;
        this._steps = stepGroup.steps.map((step: any) => stepFactory.createStep(step, processConfigurationPayExemptions,processConfigurationAuthorizations));
    }

    public get name(): string {
        return this._name;
    }

    public get steps(): Step[] {
        return this._steps;
    }

    public get order() {
        return this._order;
    }

    public get type() {
        return this._type;
    }
}